import { createScreenView, SCREEN_VIEWS } from '@/global/composables/table/useScreenView'

/**
 * How the item-execution listing splits the screen with the map.
 *
 * Opens on the split: the route on the map is what this screen is looked at for.
 */
export const itemExecutionScreenView = createScreenView({
  initialView: SCREEN_VIEWS.split
})
